import React from "react";
import { ModalTitleStyle as TitleStyle } from "../../../common/General/styles/CommonStyles";

export { TitleStyle };

export function ResetButtonStyle({ children }) {
  return <div className="text-center mt-4">{children}</div>;
}
